import { render, staticRenderFns } from "./ok.vue?vue&type=template&id=0b9fd3ec&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b9fd3ec')) {
      api.createRecord('0b9fd3ec', component.options)
    } else {
      api.reload('0b9fd3ec', component.options)
    }
    module.hot.accept("./ok.vue?vue&type=template&id=0b9fd3ec&", function () {
      api.rerender('0b9fd3ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/smileys/ok.vue"
export default component.exports